import { Button, Result } from "antd"

interface ErrorFallbackProps {
  error: any
  resetBoundary?: () => void
  resetErrorBoundary?: () => void
}

export function ErrorFallback({ error, resetBoundary, resetErrorBoundary }: ErrorFallbackProps) {
  const reset = resetBoundary || resetErrorBoundary || (() => window.location.reload())

  return (
    <Result
      status="500"
      title="500"
      subTitle={
        <>
          <p>Đã xảy ra lỗi</p>
          <pre style={{ color: "red" }}>{error?.message}</pre>
        </>
      }
      extra={
        <Button type="primary" onClick={reset}>
          Thử lại
        </Button>
      }
    />
  )
}
